import { getRgObjectsOfType as d, RG_TYPE as r } from "@project-rouge/rg-core";
const m = (o, t) => {
  const i = d(o, r.Building).map((e) => l(e, t));
  return Math.max(0, ...i);
};
function l(o, t) {
  const n = o.data.levels.find((e) => e.isPodium && e.levelIndex === t);
  if (!n)
    return 0;
  const i = o.data.levels.find((e) => e.levelIndex === t + 1);
  return i ? i.floorWorldBottom - n.floorWorldBottom : 0;
}
export {
  m as getLevelPodiumHeight
};
//# sourceMappingURL=index28.js.map
